import fetch from '../js/fetch';
import fetch2 from '../js/fetch2';

// query system info from type
export function getSystormType(params) {
  return fetch('/v1/config/public/list', params);
}

// getFoxNonce
export function getFoxNonce(address) {
  return fetch('/v1/market/nonce', {address});
}

// foxLogin
export function foxLogin(params) {
  return fetch('/v1/market/login', params)
}

// foxLogout
export function foxLogout() {
  return fetch('/v1/market/logout')
}

export function logOut(_this) {
  localStorage.removeItem('token')
  _this.setFromAddress && _this.setFromAddress(null);
  // if (_this.$route.path !== '/') {
  //   _this.$router.push('/');
  // } else {
  //   window.location.reload()
  // }
  // window.location.reload()
  _this.setIsLogin && _this.setIsLogin(false);
}

// getScAddress
export function getScAddress() {
    return fetch2(`/v1/market/scAddress`)
}
